<template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    :class="$vuetify.breakpoint.name == 'xs' ? 'mobile-container' : ''"
    class="mrc_mainnav_container pt-n1 pb-n1 align-center"
    fixed
    color="white"
    :height="56"
    style="cursor: pointer"
    :flat="false"
    :clipped-right="$vuetify.breakpoint.lgAndUp"
    v-if="!hidden"
  >
    <!-- 进度条 -->
    <Progress />
    <!-- 进度条 -->
    <v-toolbar-title
      @dblclick="changeDemo"
      v-if="$vuetify.breakpoint.name != 'xs'"
      class="ml-0 pr-4 py-2 align-start d-flex mrc_toolbar_title"
    >
      <svg-icon
        width="192px"
        height="40px"
        :iconClass="logo"
        v-if="
          !curAppInfo ||
          !curAppInfo['user'] ||
          !curAppInfo['user']['logo'] ||
          logoError
        "
      />
      <v-img
        :src="curAppInfo['user']['logo']"
        v-else
        width="100%"
        max-height="40"
        contain
        position="center center"
        @error="logoError = true"
      />
    </v-toolbar-title>
    <v-divider vertical></v-divider>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          @click="onStretch"
          height="32"
          width="32"
          class="mx-4"
        >
          <svg-icon size="24" fill="currentColor" iconClass="service" />
        </v-btn>
      </template>
      <span>{{
        drawer
          ? $t("message_essweb_navi_tools_hideMenuTip")
          : $t("message_essweb_navi_tools_showMenuTip")
      }}</span>
    </v-tooltip>
    <Breadcrumb :hidden="hiddenBread" />

    <v-spacer></v-spacer>
    <v-switch
      v-if="showDemo"
      v-model="viewkey"
      height="32"
      class="mt-5"
      :label="viewkey ? '查看Label Key' : '关闭Label Key'"
    ></v-switch>
    <v-switch
      v-if="showDemo"
      v-model="demo"
      height="32"
      class="mt-5"
      :label="demo ? '演示模式开启' : '演示模式关闭'"
    ></v-switch>
    <span v-if="allCompany.length == 1" class="pl-5 pr-5 text-subtitle-2">
      <!-- 2020-10-14 mel-->
      <!-- {{ allCompany[0]["name"] }} -->
    </span>
    <v-menu offset-y small max-height="300" v-else>
      <template v-slot:activator="{ on }">
        <v-sheet
          v-on="on"
          v-if="selectCompany"
          class="
            text-button
            px-2
            mx-2
            text-capitalize
            d-flex
            align-center
            text-body-2
          "
        >
          <div class="px-1 text-truncate">
            {{ allCompany.find(ele["uuid"] === selectCompany)["name"] }}
          </div>
          <v-spacer></v-spacer>
          <i class="material-icons-round text--secondary"
            >arrow_drop_down</i
          ></v-sheet
        >
      </template>
      <v-list dense>
        <v-list-item
          v-for="(item, index) in allCompany"
          :key="index"
          @click="selectCompany = item['uuid']"
        >
          <v-list-item-title>{{ item["name"] }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <span v-if="companyLang.length == 1" class="pl-5 pr-5 text-subtitle-2">
      <!-- <span class="material-icons-round">g_translate</span> -->
      <!-- 2020-10-14 mel-->
      <!-- {{ companyLang[0]["text"] }} -->
    </span>
    <v-menu offset-y small max-height="300" v-else>
      <template v-slot:activator="{ on }">
        <v-sheet
          v-on="on"
          class="
            text-button
            px-2
            mx-2
            text-capitalize
            d-flex
            align-center
            text-body-2
          "
        >
          <div class="px-1 text-truncate">
            {{ showLang }}
          </div>
          <v-spacer></v-spacer>
          <i class="material-icons-round text--secondary"
            >arrow_drop_down</i
          ></v-sheet
        >
      </template>
      <v-list dense>
        <v-list-item
          v-for="(item, index) in companyLang"
          :key="index"
          @click="selectLang = item['value']"
        >
          <v-list-item-title>{{ item["text"] }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- 通知 取消功能-->
    <v-badge color="error" content="8" overlap bordered right v-if="0">
      <v-btn icon class="mr-2 ml-2" small @click.stop="onPop">
        <i class="material-icons-round">notifications</i>
      </v-btn>
    </v-badge>
    <!--pop模式通知，暂时废弃-->
    <v-menu left bottom offset-y max-height="400">
      <template v-slot:activator="{ on }">
        <!-- <v-badge color="red" content="8" v-on="on"> -->
        <v-btn icon v-on="on" class="mr-2" v-show="false">
          <i class="material-icons-round">notifications</i>
        </v-btn>
        <!-- </v-badge> -->
      </template>
      <v-card dense width="200">
        <v-card-title class="pt-0 pb-0 d-flex align-center flex-grow-1 title"
          >Notifications</v-card-title
        >
        <v-divider />
        <v-card-text>
          <v-list>
            <v-list-item></v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="text-center d-flex">
          <v-btn small text color="primary" class="flex-grow-1">全部已读</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <!-- 全屏 -->
    <!-- 暂时不显示 -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-show="false"
          height="32"
          width="32"
          v-on="on"
          :class="fullScreen ? ' mr-2 ml-2' : ' mr-2 ml-2'"
          @click="openFullScreen"
        >
          <i class="material-icons-round">{{
            fullScreen ? "fullscreen_exit" : "fullscreen"
          }}</i>
        </v-btn>
      </template>
      <span>{{ fullScreen ? "退出全屏" : "进入全屏" }}</span>
    </v-tooltip>
    <!-- 個人中心 -->
    <v-menu
      left
      bottom
      offset-y
      class="rounded-lg elevation-4"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <StaffAvatar
          :size="36"
          @error="onAvatarError"
          :src="
            curAppInfo
              ? curAppInfo['user']['staff_avatar']
                ? curAppInfo['user']['staff_avatar']
                : null
              : null
          "
          :staff_name="
            curAppInfo
              ? curAppInfo['user']['preferred_name']
                ? curAppInfo['user']['preferred_name']
                : ''
              : ''
          "
          v-on="on"
        />
      </template>

      <v-sheet
        width="250"
        class="
          pb-3
          align-center align-items-center
          text-center
          d-flex
          flex-column
          justify-start
        "
      >
        <v-sheet
          height="60"
          class="max-width"
          color="primary lighten-2"
        ></v-sheet>
        <v-file-input
          id="avatar"
          v-show="false"
          @change="chooseUploadFile"
        ></v-file-input>
        <v-hover v-slot:default="{ hover }" class="mt-n9 mb-4 white--text">
          <StaffAvatar
            :size="72"
            type="head"
            @error="(err) => (isError = err)"
            :src="
              curAppInfo
                ? curAppInfo['user']['staff_avatar']
                  ? curAppInfo['user']['staff_avatar']
                  : null
                : null
            "
            :staff_name="
              curAppInfo
                ? curAppInfo['user']['preferred_name']
                  ? curAppInfo['user']['preferred_name']
                  : ''
                : ''
            "
          >
            <template v-slot:default>
              <v-sheet
                style="
                  position: absolute;
                  background: rgba(0, 0, 0, 0.4);
                  font-size: 12px;
                "
                class="
                  d-flex
                  text-center
                  align-center
                  justify-center
                  white--text
                "
                width="100%"
                height="100%"
                v-if="uploading"
              >
                <v-progress-circular
                  indeterminate
                  :rotate="10"
                  :size="24"
                  :width="2"
                  color="primary"
                ></v-progress-circular>
              </v-sheet>
              <v-sheet
                style="
                  position: absolute;
                  background: rgba(0, 0, 0, 0.4);
                  font-size: 12px;
                "
                class="
                  d-flex
                  text-center
                  align-center
                  justify-center
                  white--text
                "
                width="100%"
                height="100%"
                v-if="hover && !uploading"
              >
                <v-btn
                  icon
                  x-small
                  :ripple="false"
                  color="white"
                  class="ma-1"
                  @click="toUploadAvatar"
                >
                  <span class="material-icons-round"> edit </span>
                </v-btn>
                <v-btn
                  icon
                  x-small
                  @click="onDeleteAvatar"
                  :ripple="false"
                  color="white"
                  class="ma-1"
                  v-if="
                    !isError && curAppInfo && curAppInfo['user']['staff_avatar']
                  "
                  ><span class="material-icons-round"> delete </span>
                </v-btn>
              </v-sheet>
            </template>
          </StaffAvatar>
        </v-hover>
        <!-- 2020-10-26 brain 取消顯示 -->
        <!-- <v-chip small color="primary" class="mb-2">
          {{
            curAppInfo
              ? curAppInfo.user.is_manager
                ?  $t('label_essweb_navi_adminMemberLabel')
                : $t('label_essweb_navi_generalMemberLabel')
              :  $t('label_essweb_navi_generalMemberLabel')
          }}
        </v-chip> -->
        <span class="title mb-2 max-width text-truncate px-3">
          {{
            curAppInfo
              ? $getCommonLangValue(curAppInfo.user.preferred_name)
              : $t("label_essweb_navi_notLoginLabel")
          }}
        </span>
        <span class="caption text--secondary mb-2 max-width text-truncate px-3"
          >{{ $t("label_essweb_navi_numberLabel") }}:{{
            curAppInfo
              ? curAppInfo.user.staff_code
                ? curAppInfo.user.staff_code
                : "---"
              : "---"
          }}</span
        >
        <span
          class="caption text--secondary mb-4 max-width text-truncate px-3"
          >{{
            $getCommonLangValue(
              curAppInfo
                ? curAppInfo.user.job_post_name
                  ? curAppInfo.user.job_post_name
                  : "---"
                : "---"
            )
          }}</span
        >
        <v-btn
          class="white--text text-capitalize"
          rounded
          color="primary"
          @click="showChangeP = true"
          >{{ $t("label_ChangePassword") }}</v-btn
        >
        <div class="max-width pa-2 pt-6">
          <v-divider class="max-width"></v-divider>
        </div>
        <v-btn
          @click="logOut"
          class="text-capitalize mx-auto px-3"
          color="primary"
          retain-focus-on-click
          depressed
          small
          text
          >{{ $t("label_essweb_navi_logOutBtnLabel") }}</v-btn
        >
      </v-sheet>
    </v-menu>
    <!-- 重置密码 -->
    <changePassword
      :show="showChangeP"
      @close="showChangeP = false"
      @onSubmit="onSubmit"
    />
  </v-app-bar>
</template>
<script>
import Progress from "@/Layout/components/Progress";
import changePassword from "@/Layout/components/changePassword";
import Breadcrumb from "@/Layout/components/breadcrumbs";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "Navi",
  components: {
    Breadcrumb,
    Progress,
    changePassword,
  },
  computed: {
    // companyLang 公司可选语言list
    ...mapGetters([
      "AppInfo",
      "companyLang",
      "defaultLang",
      "companyLogo",
      "showLang",
      "isDemo",
      "loginEncryptKey",
    ]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    logo() {
      return process.env.NODE_ENV == "production"
        ? "logoV1_ESS_full_e_blue"
        : "logoV1_ESS_full_e_blue_test";
    },
    hiddenBread() {
      switch (this.$route.path) {
        // case "/dashboard":
        //   return true;
        //   break;
        case "/404":
          return true;
          break;
        case "/net_error":
          return true;
          break;
        case "/system_error":
          return true;
          break;
        default:
          return false;
          break;
      }
    },
    selectLang: {
      get() {
        // console.log(this.defaultLang);
        return this.defaultLang;
      },
      set(val) {
        this.$store.dispatch("setDefaultLang", val);
        // // 通知后端修改语言，用于错误信息翻译
        // this.$Request({
        //   method: "POST",
        //   table: "mrbase_sys_language_master",
        //   url: "/user/language/update-language/",
        //   data: {
        //     language_code: val ? val : "en",
        //   },
        //   type: "lang",
        //   global: false,
        // });
      },
    },
    allCompany() {
      let arr = [];
      if (this.curAppInfo) {
        arr.push({
          name: this.curAppInfo["user"]["org_level_name"],
          uuid: this.curAppInfo["user"]["org_level_uuid"],
        });
      }
      return arr;
    },
    selectCompany() {
      return this.allCompany.length
        ? this.allCompany[0]["org_level_uuid"]
        : null;
    },
  },
  props: {
    hidden: { default: false, type: Boolean },
    stretchL: { default: false, type: Boolean },
    popR: { default: false, type: Boolean },
  },
  async created() {
    await this.$store.dispatch("getLoginEncryptKey");
  },
  data() {
    return {
      drawer: true,
      isError: false,
      pop: false,
      logoError: false,
      showDemo: false,
      demo: false,
      viewkey: false,
      showChangeP: false,
      uploading: false,
      avatarColor: "gery lighten-3",
      fullScreen: false,
      LangList: [
        //此处配置图标和显示标题
        // {
        //   uuid: "0",
        //   is_default: false,
        //   language_name: "繁体中文(香港)",
        //   language_code: "zh-Hk",
        // },
        // {
        //   uuid: "1",
        //   is_default: true,
        //   language_name: "英语",
        //   language_code: "en",
        // },
        // {
        //   uuid: "2",
        //   is_default: false,
        //   language_name: "中文(简体)",
        //   language_code: "zh-CN",
        // },
        // {
        //   uuid: "3",
        //   is_default: false,
        //   language_name: "Japanse",
        //   language_code: "ja",
        // },
        // {
        //   uuid: "4",
        //   is_default: false,
        //   language_name: "德语",
        //   language_code: "de",
        // },
      ], //可选语言列表
    };
  },
  watch: {
    demo(val) {
      this.$store.dispatch("setDemo", val);
    },
    viewkey(val) {
      this.$store.dispatch("setViewKey", val);
    },
    stretchL(val) {
      this.drawer = val;
    },
  },
  mounted() {
    const that = this;
    this.$store.dispatch("setViewKey", false);
    if (process.env.NODE_ENV == "production") {
      this.$store.dispatch("setDemo", false);
    }
    this.demo = this.isDemo;
    if (this.$vuetify.breakpoint.name == "xs") {
      this.drawer = false;
    }
    if (
      this.curAppInfo &&
      this.curAppInfo["user"] &&
      this.curAppInfo["user"]["uuid"]
    )
      this.getLogo(this.curAppInfo["user"]["uuid"]).then((res) => {
        that.curAppInfo["user"]["logo"] =
          typeof res.data == "string" ? res.data : "";

        that.$store.dispatch(
          "setLogo",
          typeof res.data == "string" ? res.data : ""
        ); //保存logo，brain
        that.$store.dispatch("setAppInfo", JSON.stringify(that.curAppInfo));
      });
    // //监听接收消息
    // this.$messaging
    //   .getToken()
    //   .then(currentToken => {
    //     if (currentToken) {
    //       window.localStorage.setItem("currentToken", currentToken);
    //       console.log(currentToken);
    //     } else {
    //       // Show permission request.
    //       console.log(
    //         "No Instance ID token available. Request permission to generate one."
    //       );
    //     }
    //   })
    //   .catch(err => {
    //     console.log("An error occurred while retrieving token. ", err);
    //     window.localStorage.setItem("currentToken", "");
    //   });
    // this.$messaging.onMessage(payload => {
    //   console.log("Message received. ", payload);
    //   if (that.MessageList != "") {
    //     if (that.MessageList.indexOf("&*") != -1) {
    //       that.MessageList =
    //         that.MessageList +
    //         "&*" +
    //         JSON.stringify({ read: false, data: payload });
    //     } else {
    //       that.MessageList =
    //         that.MessageList +
    //         "&*" +
    //         JSON.stringify({ read: false, data: payload });
    //     }
    //   } else {
    //     that.MessageList = [];
    //     that.MessageList = JSON.stringify({ read: false, data: payload });
    //   }
    //   that.$store.dispatch("setMessageList", that.MessageList.split("&*"));
    // });
    // this.$messaging.onTokenRefresh(() => {
    //   that.$messaging
    //     .getToken()
    //     .then(refreshedToken => {
    //       that.$messaging
    //         .getToken()
    //         .then(currentToken => {
    //           if (currentToken) {
    //             window.localStorage.setItem("currentToken", currentToken);
    //             console.log(currentToken);
    //           } else {
    //             // Show permission request.
    //             console.log(
    //               "No Instance ID token available. Request permission to generate one."
    //             );
    //           }
    //         })
    //         .catch(err => {
    //           console.log("An error occurred while retrieving token. ", err);
    //           window.localStorage.setItem("currentToken", "");
    //         });
    //     })
    //     .catch(err => {
    //       console.log("Unable to retrieve refreshed token ", err);
    //     });
    // });
  },
  methods: {
    changeDemo() {
      String(process.env.NODE_ENV) != "production" &&
      String(process.env.NODE_ENV) != "hk" &&
      String(process.env.NODE_ENV) != "hrtest"
        ? (this.showDemo = !this.showDemo)
        : null;
    },
    onAvatarError() {
      const that = this;
      that
        .onUploadAvatar(that.curAppInfo["user"]["thumbnail_img"])
        .then((resul) => {
          that.curAppInfo["user"]["staff_avatar"] = resul.data["files"]
            ? resul.data["files"][0]?.path
            : null;
          that.curAppInfo["user"]["thumbnail_img"] = resul.data["files"]
            ? resul.data["files"][0]?.uuid
            : null;

          that.$store.dispatch("setAppInfo", JSON.stringify(that.curAppInfo));
        });
    },
    logOut: function () {
      const that = this;
      let logo = this.companyLogo; //保存logo
      let lang = this.defaultLang; //保存lang
      localStorage.clear();
      this.$store.dispatch("setNavKey", "");
      this.$store.dispatch("setDemo", false);
      this.$store.dispatch("setLogo", logo);
      this.$store.dispatch("setDefaultLang", lang);
      this.clearAllCookie();
      that.$toPage("/login", {});
    },
    clearAllCookie: function () {
      var date = new Date();
      let Excludes = ["userInfo", "defaultUTC", "nav_base_key"]; //排除某些cookie不清空
      date.setTime(date.getTime() - 10000);
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--; ) {
          if (Excludes.indexOf(keys[i]) == -1)
            document.cookie =
              keys[i] + "=0; expire=" + date.toGMTString() + "; path=/";
        }
      }
    },
    onSubmit: function (data) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "mrbase_sys_users",
        url: "/personalcenter/save-updatepwd/",
        data: {
          user_pwd: this.$loginEncrypt({
            msg: data.renewP,
            key: this.loginEncryptKey,
          }),
          old_pwd: this.$loginEncrypt({
            msg: data.originalP,
            key: this.loginEncryptKey,
          }),
        },
        type: "lang",
      }).then((res) => {
        that.$toPage("/login", {}, "replace");
      });
    },
    async chooseUploadFile(file) {
      const that = this;
      if (!file) return;
      if (!/\.(gif|jpg|jpeg|png|GIF|JPG|PNG|webp|BMP|bmp)$/.test(file.name)) {
        this.$showMessage({
          type: "error",
          color: "error",
          text: this.$t("message_essweb_update_components_onlyUpdateImgLabel"),
        });
        return false;
      }
      if (file.size > 5 * 1000 * 1000) {
        this.$showMessage({
          type: "error",
          color: "error",
          text:
            this.$t("message_essweb_update_components_sizeLessThanLabel") +
            "5MB.",
        });
        return false;
      }
      await that
        .getUploadInfo(file.name, file.size)
        .then((res) => {
          that
            .UploadAvatar(file, res.data)
            .then((result) => {
              if (result === true) {
                that
                  .callBackUpload(1, res.data.uuid)
                  .then((resu) => {
                    if (resu.data.type == "update") {
                      // 绑定图片到员工
                      that
                        .bindAvatar(res.data.uuid)
                        .then((re) => {
                          that
                            .onUploadAvatar(res.data.uuid)
                            .then((resul) => {
                              that.curAppInfo["user"]["staff_avatar"] =
                                resul.data["files"][0]["path"];
                              that.curAppInfo["user"]["thumbnail_img"] =
                                resul.data["files"][0]["uuid"];
                              that.$store.dispatch(
                                "setAppInfo",
                                JSON.stringify(that.curAppInfo)
                              );
                            })
                            .catch((err) => {});
                        })
                        .catch((err) => {
                          //图片绑定失败
                          console.log(err);
                        });
                    } else {
                      //上报失败
                    }
                  })
                  .catch((err) => {
                    console.log((err) => {
                      //上报失败
                    });
                  });
              }
            })
            .catch((err) => {
              // 上传失败
              console.log(err);
              that.callBackUpload(0, res.data.uuid);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async UploadAvatar(file, arg) {
      const that = this;
      that.uploading = true;
      return await new Promise((reslove, reject) => {
        that.$azureUpload(
          {
            baseUrl: arg.upload_url.split("?")[0],
            sasToken: arg.sostoken,
            file: file,
            progress: (progress) => {
              // console.log(progress);
            },
            complete: (res) => {
              that.uploading = false;
              reslove(true);
            },
            error: (err) => {
              that.uploading = false;
              reject(err);
            },
            blockSize: file.size,
          },
          axios.create()
        );
      });
    },
    async callBackUpload(result, uuid) {
      const that = this;
      that.uploading = true;
      return new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/fileManager/add-file-callback/",
            data: {
              result: result,
              uuid: uuid,
            },
            type: "upload",
            global: false,
          })
          .then((res) => {
            that.uploading = false;
            reslove(res);
          })
          .catch((err) => {
            that.uploading = false;
            reject(err);
          });
      });
    },
    async onDeleteAvatar() {
      const that = this;
      // test
      // that.curAppInfo["user"]["staff_avatar"] = null;
      // that.$store.dispatch("setAppInfo", JSON.stringify(that.curAppInfo));
      // return;
      // test
      await that
        .bindAvatar("", that.curAppInfo["user"]["thumbnail_img"])
        .then((res) => {
          that.curAppInfo["user"]["staff_avatar"] = null;
          that.curAppInfo["user"]["thumbnail_img"] = "";
          that.$store.dispatch("setAppInfo", JSON.stringify(that.curAppInfo));
        });
    },
    toUploadAvatar: function () {
      $("#avatar").click();
    },
    getUploadInfo: function (name, size) {
      const that = this;
      that.uploading = true;
      return new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/fileManager/add-file-record-plan/",
            data: {
              module_uuid: "upload",
              attachment_data_field: that.curAppInfo["user"]["thumbnail_img"],
              org_level_uuid: that.curAppInfo["user"]["org_level_uuid"],
              attachment_title: name,
              attachment_size: size,
            },
            type: "upload",
            global: false,
          })
          .then((res) => {
            that.uploading = false;
            reslove(res);
          })
          .catch((err) => {
            that.uploading = false;
            reject(err);
          });
      });
    },
    async onUploadAvatar(uuid) {
      const that = this;
      that.uploading = true;
      return await new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/fileManager/get-file-info/",
            data: { uuid: uuid },
            type: "upload",
            global: false,
            notAlert: true,
          })
          .then((res) => {
            that.uploading = false;
            reslove(res);
          })
          .catch((err) => {
            that.uploading = false;
            reject(err);
          });
      });
    },
    async bindAvatar(uuid, del = "") {
      const that = this;
      that.uploading = true;
      return await new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/staff-manager/upload_staff_avatar/",
            data: {
              user_id: that.curAppInfo["user"]["user_id"],
              uuid: that.curAppInfo["user"]["uuid"],
              thumbnail_img: uuid,
              del: del,
            },
            type: "upload",
            global: false,
          })
          .then((res) => {
            that.uploading = false;
            reslove(res);
          })
          .catch((err) => {
            that.uploading = false;
            reject(err);
          });
      });
    },
    async getLogo(uuid) {
      const that = this;
      return await new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/company/get-company-logo/",
            data: {
              uuid: uuid,
            },
            type: "upload",
            global: false,
            notAlert: true,
          })
          .then((res) => {
            reslove(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    openFullScreen: function () {
      //全屏开关
      this.$toggleFullScreen(!this.fullScreen);
      this.fullScreen = !this.fullScreen;
    },
    onStretch: function () {
      this.drawer = !this.drawer;
      this.$emit("onStretch", this.drawer);
    },
    onPop: function () {
      this.$emit("onPop", !this.popR);
    },
  },
};
</script>
<style scoped>
.mrc_toolbar_title {
  width: 224px !important;
}
.mrc_mainnav_container {
  overflow: hidden;
  border-bottom: 1px solid var(--main-border-color) !important;
}
.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
  min-height: 32px !important;
}
</style>
